import { motion } from "framer-motion";
import { fadeUp, stagger } from "../animations";

const ExperienceItem = ({ role, company, period, desc, points }) => (
  <motion.div
    variants={fadeUp}
    className="relative pl-6 border-l border-yellow-400/40"
  >
    <span className="absolute -left-[6px] top-1.5 w-3 h-3 rounded-full bg-gradient-to-r from-blue-400 to-yellow-300"></span>

    <h3 className="font-semibold text-lg">{role}</h3>
    <p className="text-sm text-gray-400 mb-2">
      {company} · {period}
    </p>

    <p className="text-gray-400 text-sm mb-3">{desc}</p>

    <ul className="list-disc list-inside text-gray-400 text-sm space-y-1">
      {points.map((p, i) => (
        <li key={i}>{p}</li>
      ))}
    </ul>
  </motion.div>
);

export default function Experience() {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={stagger}
      className="max-w-5xl mx-auto px-6 py-16"
    >
      <h2 className="text-2xl font-semibold mb-10 text-yellow-300">
        Professional Experience
      </h2>

      <div className="space-y-12">

        <ExperienceItem
          role="Full Stack Developer"
          company="Sri Sadguru Hyper Technologies Pvt Ltd"
          period="Sep 2022 – Present"
          desc="Building full stack and AI-driven applications used in production environments."
          points={[
            "Designed and developed REST APIs using Python Flask and FastAPI",
            "Built admin dashboards and ERP-style systems using PHP and MySQL",
            "Integrated machine learning features such as OCR, NLP, and prediction models",
            "Worked on Flutter mobile applications connected to backend APIs",
            "Handled deployment, server configuration, and production bug fixes",
          ]}
        />

        <ExperienceItem
          role="AI/ML & Full Stack Mentor"
          company="Internship Training & Academic Projects"
          period="2+ Years"
          desc="Mentoring students and interns in real-world ML and full stack development."
          points={[
            "Guided 50+ students in Machine Learning and Full Stack project development",
            "Helped students design ML pipelines and deploy models using Flask",
            "Provided end-to-end project guidance including documentation and viva prep",
            "Reviewed code, fixed bugs, and improved project architecture",
          ]}
        />

      </div>
    </motion.section>
  );
}
